import cookie from '../module/cookie.js'

// All pages, including Varnish-cached ones, receive the same public endpoint URLs.
// The synchronization endpoint authenticates the customer and validates the request origin.
const consentConfig = window.polyestershoppen?.advertisingConsent

const readConsentFingerprint = () => {
  try {
    const value = cookie.get('cookiefirst-consent')

    if (!value) {
      return null
    }

    const { advertising, timestamp, version } = JSON.parse(value)

    if (typeof advertising !== 'boolean' || !Number.isInteger(timestamp)) {
      return null
    }

    return JSON.stringify([advertising, timestamp, version ?? null])
  } catch {
    return null
  }
}

const identity = cookie.get('external_id_sha256')

if (identity && consentConfig?.syncEndpoint) {
  // The identity cookie is only a client-side optimization. The endpoint
  // independently enforces customer authentication; no user ID is submitted.
  const storageKey = 'cookiefirst-advertising-consent-synced:' + identity
  let inProgress = false

  const wasSynced = (fingerprint) => {
    try {
      return sessionStorage.getItem(storageKey) === fingerprint
    } catch {
      return false
    }
  }

  const markSynced = (fingerprint) => {
    try {
      sessionStorage.setItem(storageKey, fingerprint)
    } catch {
      // Session storage can be unavailable. The server still prevents duplicate writes.
    }
  }

  const synchronize = async () => {
    if (inProgress) {
      return
    }

    const fingerprint = readConsentFingerprint()

    if (!fingerprint || wasSynced(fingerprint)) {
      return
    }

    inProgress = true

    try {
      // POST bypasses Varnish's normal GET cache; the custom header requires a CORS preflight cross-origin.
      const response = await fetch(consentConfig.syncEndpoint, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        cache: 'no-store',
        redirect: 'manual',
      })

      if (response.status === 204) {
        markSynced(fingerprint)
      }
    } catch {
      // Retry when CookieFirst changes again or on a subsequent page navigation.
    } finally {
      inProgress = false
    }
  }

  // A consent change may reload the page before its event handler finishes.
  // Comparing the cookie at startup also recovers those changes and cache hits.
  synchronize()

  window.addEventListener('cf_consent', () => {
    window.setTimeout(synchronize, 250)
  })
}
